import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { InstallationDetailsStore } from '@store';
import { Chart } from '../../../features/chart-bar/models/chart.model';

@Component({
  selector: 'app-generic-consumption-chart-overlay',
  templateUrl: './generic-consumption-chart-overlay.component.html',
  styleUrls: ['./generic-consumption-chart-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericConsumptionChartOverlayComponent {
  @Input() chartData: Chart;
  @Input() isElectricityConsumption = false;

  constructor(protected installationDetailsStore: InstallationDetailsStore) {}
}
